import Repository from '../axios'


export default {
  getObjectData(object_name) {
    return Repository.get(`/object/${object_name}`)
  },
  fetchLookupData(lookup_name, queryParams = '') {
    return Repository.get(`/${lookup_name}/list?is_paginate=0&${queryParams}`)
  },
  createObject(object_name, payload) {
    return Repository.post(`/${object_name}/create`, payload)
  },
  updateObject(object_name, object_id, payload) {
    return Repository.put(`/${object_name}/${object_id}/update`, payload)
  },
  getObjectDetails(object_name, object_id) {
    return Repository.get(`/${object_name}/${object_id}/view`)
  },
  deleteObject(object_name, object_id) {
    return Repository.delete(`/${object_name}/${object_id}`)
  },

  getWizardData(object_name) {
    return Repository.get(`/wizard/${object_name}`)
  },
  createWizard(object_name, payload) {
    return Repository.post(`/${object_name}/create`, payload)
  },
  updateWizard(object_name, object_id, payload) {
    return Repository.put(`/${object_name}/${object_id}/update`, payload)
  },
  getWizard(object_name, object_id) {
    return Repository.get(`/${object_name}/${object_id}/view`)
  },
  // attachments
  getAttachments(object_name, object_id) {
    return Repository.get(`/${object_name}/${object_id}/attachments`)
  },
  uploadAttachment(object_name, object_id, file) {
    return Repository.post(`/${object_name}/${object_id}/attachments`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteAttachment(object_name, object_id, attachment_id) {
    return Repository.delete(`/${object_name}/${object_id}/attachments/${attachment_id}`)
  },
};
